import axios from 'axios';
import {ModelFactory} from '@danhoss/model/factory'

export class WishListHttpClient {
    async getData() {
        const url = `/app/wishlist.php?action=get_wishlist`;
        const {data} = await axios.get(url);

        const factory = new ModelFactory();
        const products = factory.createCollectionModels('ProductModel', data.products);

        return {
            products
        };
    }

    async addProduct(productId) {
        const url = `/app/wishlist.php?action=add`;
        const {data} = await axios.post(url, {id: productId});

        const factory = new ModelFactory();
        const product = factory.createModel('ProductModel', data.product);

        return {
            product
        };
    }

    async removeProduct(productId) {
        const url = `/app/wishlist.php?action=remove&id=${productId}`;
        await axios.get(url);

        return true;
    }
}